import request from '../../utils/request';
import qs from 'qs'
import { get } from 'core-js/core/dict';

// 活码管理--查询活码
export function getActivityList(params,authorization,isloading){
  return request({
    url: '/api/qywechat/activity/get/qr_code',
    data:params,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 活码管理--新建活码
export function createActiveCode(params,authorization){
  return request({
    url: '/api/qywechat/activity/qr_code',
    method: 'post',
    data:params,
    headers: {
      "authorization": authorization
    }
  })
}
// 活码管理--编辑活码
export function editActiveCode(qrId,params,authorization){
  return request({
    url: '/api/qywechat/activity/qr_code/'+qrId,
    data:params,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}

// 活码管理--删除活码
export function delActiveCode(params,authorization){
  return request({
    url: '/api/qywechat/activity/qr_code/'+params,
    method: 'delete',
    headers: {
      "authorization": authorization
    }
  })
}

// 活码管理--批量删除活码
export function batchDelActiveCode(params,authorization){
  return request({
    url: '/api/qywechat/activity/batch/qr_code',
    data:params,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}
// 获取部门及员工
export function getActivityDepartStaff(authorization){
  return request({
    url: '/api/qywechat/depart/getActivityDepartStaff',
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}
// 根据部门名/员工名关键
export function getActivityFuSearch(params,authorization){
  return request({
    url: '/api/qywechat/depart/getActivityFuSearch',
    params,
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}

// 获取指定部门下的所有员工
export function getAllStaff(params,authorization,isloading){
  return request({
    url: '/api/qywechat/depart/getDepartStaffById',
    params,
    method: 'get',
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 获取标签组
export function activityTagType(params,authorization,isloading){
  return request({
    url: '/api/qywechat/activity/tag_type',
    params,
    method: 'get',
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 创建标签组
export function createTagGroup(params,authorization){
  return request({
    url: '/api/qywechat/activity/tag_type',
    params,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}
//创建标签
export function createTag(params,authorization){
  return request({
    url: 'api/qywechat/activity/tag',
    params,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}
//删除标签组
export function delTagGroup(groupId,authorization){
  return request({
    url: 'api/qywechat/activity/tag_type/'+groupId,
    method: 'delete',
    headers: {
      "authorization": authorization
    }
  })
}
//编辑标签组
export function editTagGroup(groupId,params,authorization){
  return request({
    url: 'api/qywechat/activity/tag_type/'+groupId,
    params,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}
//删除标签
export function delTag(tagId,authorization){
  return request({
    url: 'api/qywechat/activity/tag/'+tagId,
    method: 'delete',
    headers: {
      "authorization": authorization
    }
  })
}
//编辑标签
export function editTag(tagId,params,authorization){
  return request({
    url: 'api/qywechat/activity/tag/'+tagId,
    params,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}
// 获取欢迎语
export function getWelcome(params,authorization,isloading){
  return request({
    url: '/api/qywechat/activity/getWelcome',
    params,
    method: 'get',
    headers: {
      "authorization": authorization
    }
  },isloading)
}
//创建欢迎语
export function createWelcome(params,authorization){
  return request({
    url: 'api/qywechat/activity/createWelcome',
    data:params,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}
//编辑欢迎语
export function editWelcome(params,authorization){
  return request({
    url: 'api/qywechat/activity/updateWelcome',
    data:params,
    method: 'put',
    headers: {
      "authorization": authorization
    }
  })
}
//删除欢迎语
export function delWelcome(params,authorization){
  return request({
    url: 'api/qywechat/activity/deleteWelcome',
    data:params,
    method: 'delete',
    headers: {
      "authorization": authorization
    }
  })
}
//获取客户列表
export function getCustomer(params,authorization){
  return request({
    url: 'api/qywechat/activity/get/customer',
    data:params,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}
//活码统计

export function codeCount(params,authorization){
  return request({
    url: 'api/qywechat/activity/manageActivityCus',
    data:params,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}


//获取扫码标签
export function getCodeTags(qrId,authorization){
  return request({
    url: 'api/qywechat/activity/qr_tag/'+qrId,
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}


